<template>
  <div v-if="visible" class="maintenance-notice">
    <div class="notice-inner">
      <v-icon small color="white" class="mr-1">mdi-alert</v-icon>
      <span class="text" v-t="'maintenanceNotice'"></span>
      <v-icon
        small
        color="white"
        class="close-btn ml-1"
        @click="visible = false"
      >
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenanceNotice",
  data() {
    return {
      visible: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.maintenance-notice {
  width: 100%;
  display: flex;
  justify-content: center;
  // 中央のバナー本体だけがクリックを受け取り、周囲は地図操作を妨げない
  pointer-events: none;

  .notice-inner {
    pointer-events: auto;
    display: inline-flex;
    align-items: center;
    max-width: calc(100vw - 20px);
    padding: 8px 12px;
    background-color: rgba(211, 47, 47, 0.94);
    color: white;
    border-radius: 8px;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.4;
    text-align: left;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);

    .text {
      flex: 1;
    }
    .close-btn {
      cursor: pointer;
    }
  }
}
</style>

<i18n>
{
  "ja": {
    "maintenanceNotice": "緊急メンテナンスにより更新が停止しております。"
  },
  "en": {
    "maintenanceNotice": "Updates are currently suspended due to emergency maintenance."
  }
}
</i18n>
